const processLink = (link) => {
  //if the link is relative or an anchor link, navigate to it, otherwise open it in a new tab
  if (link.startsWith("/") || link.startsWith("#")) {
    let finalUrl = link

    // For relative links, prepend language code if not already present
    if (link.startsWith("/") && !link.startsWith("//")) {
      // Check if URL already has language code
      const hasLangCode = link.match(/^\/([a-z]{2})(\/|$)/)

      if (!hasLangCode && typeof localStorage !== 'undefined') {
        // Get current language from localStorage
        const storedLang = localStorage.getItem('current-site-language')
        let langCode

        try {
          langCode = storedLang ? JSON.parse(storedLang) : 'en'
        } catch (e) {
          langCode = storedLang || 'en'
        }

        // Prepend language code if not default (en) and not an admin URL
        if (langCode && langCode !== 'en' && !link.startsWith('/admin')) {
          finalUrl = `/${langCode}${link}`
        }
      }
    }

    // Use window.location for internal navigation to avoid SSR fetch issues
    window.location.href = finalUrl
    return
  }
  //open the link in a new tab
  window.open(link)
}
const resolveActionHandler = ({
  actionMap,
  itemsAsLinks = false,
  onItemClick,
}) => {
  return (item) => {
    let action

    //resolve the action from the actionMap
    if (item.options?.action) {
      action =
        typeof item.options.action === "function"
          ? item.options.action
          : actionMap?.[item.options.action]
    }
    //if no option action is found, check the itemsAsLinks flag
    if (!action && itemsAsLinks && item.link && item.link[0]?.url) {
      //if the item has a link, navigate to it
      action = () => processLink(item.link[0].url)
    }
    //run the action
    action?.(item)

    //hide the menu if the hideOnItemClick flag is set
    onItemClick && onItemClick(item)
  }
}

export default resolveActionHandler
